import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from 'react';
import Modal from "../../Modal.tsx";
import Axios from "../../../Axios.js";
import { Asset, AssetTable } from "../../Asset.tsx";

const ModalLocation = ({ isOpen, onClose, data, toggle }) => {
    const { t } = useTranslation();
    const [errors, setErrors] = useState({});

    const [name, setName] = useState("");
    const [id, setId] = useState(null);

    useEffect(() => {
        setErrors({});
        if (data != null && data) {
            setName(data.name);
            setId(data.id_location);
        }
        else {
            setName('');
            setId(null);
        }
    }, [data, isOpen]);

    const validateForm = () => {
        const newErrors = {};

        //REGEX POUR NAME INTERDIRE , ET /
        let regex = new RegExp(/^[^,\/]+$/);

        if (name === "" || name == null || name.length < 3) {
            newErrors.name = t("location name too short");
        }
        else if (name.length > 255) {
            newErrors.name = t("location name too long");
        }
        else if (!regex.test(name)) {
            newErrors.name = t("location name contains invalid characters (, or /)");
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (validateForm()) {
            toggle();

            let json = {
                name: name,
                id: id,
            };

            updateLocation(json)
            onClose(json, 'location');
        }
    };

    const updateLocation = async (data) => {
        console.log("update location");

        if (data && Object.keys(data).length > 0) {

            if (data) {
                try {
                    const config = {
                        headers: {
                            "Content-Type": "application/json",
                            "auth-token": sessionStorage.getItem('token')
                        },
                        withCredentials: true
                    };

                    const response = (data.id == null) ?
                        await Axios.post(`api/fp/location/`, data, config) :
                        await Axios.put(`api/fp/location/?id=${data.id}`, data, config);

                    if (response.status === 200) {
                        console.log("location updated")
                        return;
                    }
                    console.log(response);
                }

                catch (error) {
                    console.error("Error during modify task:", error);
                }
            }
        }
    }

    if (!isOpen) return null;

    let form = (
        <form className="p-4" onSubmit={(e) => { handleSubmit(e) }}>
            <div className="grid gap-4 mb-4 grid-raws-2">
                <div className="mb-2 col-span-1">
                    <label htmlFor="category" className="modal-label"> {t('location')} </label>
                    <input
                        id="name"
                        className="modal-input"
                        required
                        value={name}
                        placeholder={t('name')}
                        onChange={(e) => { setName(e.target.value) }}
                    />
                    {errors.name && <p className="text-red-500">{errors.name}</p>}
                </div>
                {/*
                <div>
                    <label className="modal-label"> {t('Propositions')} </label>
                    <Asset
                        asset={AssetTable.asset}
                        onClick={item => setName(item.name)}
                        icon={false}
                    />
                </div>
                */}

            </div>
            <div className="flex justify-end">
                <button
                    type="submit"
                    className="form-button-validate"
                >
                    {t("validate")}
                </button>
            </div>
        </form>
    );

    return (
        <Modal
            isOpen={isOpen}
            toggle={toggle}
            title={t('location')}
            form={form}
            width={55}
        />
    );
}

export default ModalLocation;